export default __webpack_public_path__ + "0e1118fc11a4daaa63095e9eddf2dee5.svg";